const Button = ({ children, onClick, className }) => {
    return (
      <button
        className={`bg-blue-500 hover:bg-blue-600 text-white py-2 px-6 rounded-lg shadow-md ${className}`}
        onClick={onClick}
      >
        {children}
      </button>
    );
  };
  
  export default Button;
  